<template>

  <ConfirmDialogue ref="confirmDialogue" />
  <MessageDialogue ref="messageDialogue" />

  <edit-template :breadcrumbs="breadcrumbs" :nav="nav">
    <div class="load-container" :class="{'load' : isLoad}">
      <div class="c-counter">
        <div class="label"> Количество <br /> этажей </div>
        <CounterPicker :value="floors.length" :size="'large'" @setValue="(val) => { setCountFloors(val) }" />
      </div>
      <div class="row">
        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3" v-for="(floor, index) in floors" :key="index">
          <div class="floors__item">
            <div class="floors__number">
              {{ floor.floor }} этаж
            </div>
            <ImagePicker class="floors__img" v-model="floor.link"/>
          </div>
        </div>
      </div>
    </div>

    <!-- Управление страницей -->
    <div class="btn-group">
      <!-- Назад к тех. параметрам -->
      <router-link :to="{name: 'PageHouseEditDocuments', params: {organization_id: organization_id, house_id: house_id} }" class="btn btn--lg btn--outline">
        <img class="btn--ico btn--ico--left" src="@/assets/img/prew-arrow-blue.svg">
        <div class="btn--text"> вернуться </div>
        <div class="btn--loader"></div>
      </router-link>
      <!-- Сохранить -->
      <a class="btn btn--lg btn--default" @click="saveFloors($event)" href="javascript:;">
        <img class="btn--ico btn--ico--left" src="@/assets/img/check-white.svg">
        <div class="btn--text"> Сохранить </div>
        <div class="btn--loader"></div>
      </a>
    </div>

  </edit-template>

</template>


<script setup>
  import EditTemplate from '@/components/house/EditTemplate.vue';
  import ConfirmDialogue from '@/components/modals/ConfirmDialogue.vue';
  import ImagePicker from '@/components/ux/ImagePicker.vue'
  import CounterPicker from '@/components/ux/CounterPicker.vue';
  import MessageDialogue from '@/components/modals/MessageDialogue.vue';
</script>

<script>
  export default {
    name: 'EditFloorPlan',
    data: () => ({
      isLoad: true,

      nav: [],
      breadcrumbs: [],
      
      house: null,
      organization: null,

      floors: [],

    }),
    computed: {
      organization_id () {
        return this.$route.params.organization_id;
      },
      house_id () {
        return this.$route.params.house_id;
      },
    },
    created () {

      this.nav =  [
        {name: 'Адрес дома', isActive: false, link: {name: 'PageHouseEdit', params: {organization_id: this.organization_id, house_id: this.house_id}}},
        {name: 'Тех. параметры', isActive: false, link: {name: 'PageHouseEditParam', params: {organization_id: this.organization_id, house_id: this.house_id}}},
        {name: 'Структура', isActive: false, link: {name: 'PageHouseEditStructure', params: {organization_id: this.organization_id, house_id: this.house_id}}},
        {name: 'Документы', isActive: false, link: {name: 'PageHouseEditDocuments', params: {organization_id: this.organization_id, house_id: this.house_id}}},
        {name: 'Планы этажей', isActive: true},
      ];
      Promise.all([
        this.loadOrganization(), 
        this.loadHouse(), 
        this.loadFloor(), 
      ])
      .then(() => {
        this.beforeRender();
        this.isLoad = false;
      })
      .catch((e)=> {
        console.log(e);
        this.isError = true;
        this.isLoad = false;
      })
    },
    methods: {
      
      setCountFloors (val) {
        // for (let i = this.floors.length; i <= val; i++) {
          
          // this.$helpers.resizeArray(this.floors, i, {floor: val, link: null});

        // }

        this.$helpers.resizeArray(this.floors, val, {floor: val, link: null});


      },

      async saveFloors (e) {
        let btn = e.currentTarget;
        btn.classList.add('btn--load');
        try {
          await this.axios.patch(this.$store.state.api_endpoint + '/houses/' + this.house.id + '/floorImages', this.floors);
          this.$refs.messageDialogue.show({message: 'Планы этажей сохранены', okButton: 'Подтвердить'});
        } catch (e) {
          this.$refs.messageDialogue.show({message: e.message, okButton: 'Подтвердить'});
        }
        btn.classList.remove('btn--load');
      },

      beforeRender () {
        this.breadcrumbs = [
          {name: this.$route.meta.name, link: this.$route.matched[0].path, ico: this.$route.meta.ico },
          {name: this.organization.name, link: {name: 'PageOrganization', params: {organization_id: this.organization_id}}},
          {name: this.house.address, link: {name: 'PageHouseMain', params: {organization_id: this.organization_id, house_id: this.house_id}}},
          {name: 'Планы этажей', link: '' },
        ];
        if(this.floors.length == 0) {
          this.setCountFloors(1);
        }
      },
      
      async loadOrganization () {
        const {data} = await this.axios.get(this.$store.state.api_endpoint + '/companies/' + this.organization_id);
        this.organization = data;
      },
      
      async loadHouse () {
        const {data} = await this.axios.get(this.$store.state.api_endpoint + '/houses/' + this.house_id + '?detailed=true');
        this.house = data;
      },
      
      async loadFloor () {
        const {data} = await this.axios.get(this.$store.state.api_endpoint + '/houses/' + this.house_id + '/floorImages');
        this.floors = data;
      },

    },

  }

</script>

<style scoped>


  .btn-group {
    border-top: 1px solid #d9e4eb;
    padding: 30px;
    justify-content: space-between;
  }

  .load-container {
    padding: 30px;
    padding-bottom: 0px;
  }
 

  .floors {
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-bottom: 30px;
  }

  .floors__item {
    position: relative;
    margin-bottom: 30px;
  }
  .floors__img {
    width: 100%;
    aspect-ratio: 9 / 6;
  }


  .floors__number {
    font-weight: 500;
    position: absolute;
    left: 20px;
    z-index: 9999;
    top: 20px;
    color: #ffffff;
    background: rgb(0 141 210);
    padding: 5px 20px;
    border-radius: 4px;
  }

  .c-counter {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 30px;
    margin-bottom: 30px;
  }


</style>